// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { InterceptionDirectionSchema } from '../inputTypeSchemas/InterceptionDirectionSchema'
import { HttpMethodSchema } from '../inputTypeSchemas/HttpMethodSchema'

/////////////////////////////////////////
// HTTP INTERCEPTION RULE SCHEMA
/////////////////////////////////////////

export const HttpInterceptionRuleSchema = z.object({
  direction: InterceptionDirectionSchema,
  methods: HttpMethodSchema.array(),
  urlPattern: z.string(),
  enabled: z.boolean(),
  description: z.string().nullable(),
})

export type HttpInterceptionRule = z.infer<typeof HttpInterceptionRuleSchema>

export default HttpInterceptionRuleSchema;
